import { Badge } from '@mantine/core';
import { IconBarcode } from '@tabler/icons-react';
import classes from './CardMetaBadge.module.css';

interface ArticleNumberBadgeProps {
  articleNumber: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  showIcon?: boolean;
  style?: React.CSSProperties;
  appearance?: 'default' | 'card';
}

export function ArticleNumberBadge({
  articleNumber,
  size = 'sm',
  showIcon = true,
  style,
  appearance = 'default',
}: ArticleNumberBadgeProps) {
  if (appearance === 'card') {
    return (
      <span className={`${classes.badge} ${classes.article}`} style={style} title={articleNumber}>
        {showIcon && <IconBarcode size={9} className={classes.icon} stroke={2} />}
        <span className={`${classes.label} ${classes.articleLabel}`}>{articleNumber}</span>
      </span>
    );
  }

  const iconSize = size === 'lg' ? 14 : size === 'sm' ? 12 : 10;
  const gap = size === 'lg' ? '4px' : '3px';

  return (
    <Badge color="gray" variant="light" size={size} style={style}>
      <div style={{ display: 'flex', alignItems: 'center', gap }}>
        {showIcon && <IconBarcode size={iconSize} />}
        {articleNumber}
      </div>
    </Badge>
  );
}
